import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext';

const ProjetCard = ({ projet, delay = 0 }) => {
  const { language, t } = useContext(LanguageContext);
  return (
    <Link to={`/projets/${projet.slug}`} className="card" data-aos="fade-up" data-aos-delay={delay}>
      <div className="card__img">
        <img src={projet.cover} alt={projet.name[language]} loading="lazy" />
      </div>
      <div className="card__body">
        <span className="card__type">
          {projet.type[language]}
          {projet.place ? ` · ${projet.place}` : ''}
        </span>
        <h3>{projet.name[language]}</h3>
        <span className="card__more">{t.projects.view} →</span>
      </div>
    </Link>
  );
};

export default ProjetCard;
